export interface HdmgdjSeoEntry {
  title: string;
  description?: string;
  keywords?: string;
}

export const hdmgdjSeo = {
  home: {
    title: "黄豆魔改短剧 - 老套路魔改出新爽感",
    description:
      "黄豆魔改短剧，老套路魔改出新爽感！经典桥段反转升级，脑洞剧情高能不断，爽点密集一集上头。海量热门短剧随心看，猜不到下一秒的魔改神操作，让每一集都有新鲜感，越看越上瘾，追剧停不下来。",
    keywords: "黄豆魔改短剧",
  } as HdmgdjSeoEntry,
  download: {
    title: "黄豆魔改短剧免费版下载-黄豆魔改短剧APP下载-黄豆魔改短剧",
    description:
      "黄豆魔改短剧APP下载，一键安装，随时随地追剧。老套路魔改出新爽感，脑洞反转，一集上头。立即下载黄豆魔改短剧，精彩不停，越看越上瘾！",
    keywords: "黄豆魔改短剧免费版下载,黄豆魔改短剧APP下载",
  } as HdmgdjSeoEntry,
  report: {
    title: "投诉举报",
  } as HdmgdjSeoEntry,
};